const data = [
    {
      id: 1,
      image: "images/image-2.png",
      image: "images/image-2.png",
      title: "Youtube",
      desc: "Aashi Supriya Sudhir",
      link: "https://www.youtube.com/@AashiSupriyaSudir",
    },
    {
      id: 2,
      image: "images/image-3.png",
      title: "Facebook Page",
      desc: "CPI Mallikarjun Page",
      link: "https://www.facebook.com/cpimallikarjun",
    },
    {
      id: 3,
      image: "images/image-33.png",
      title: "Facebook Page and Instagram",
      desc: "London American City College",
      link: "https://www.facebook.com/laccuae",
    },
   
  ]
  export default data
